module.exports = __webpack_public_path__ + "static/media/steam.bb414e2a.svg";